import React, {Component} from 'react';
import {connect} from "react-redux";
import ApplicationPolicy from "../components/applicationPolicy";
import {
	changeActiveTab, changeApplicationPolicySettings,
	checkUserOverviewTabCheckBox, requestApplicationAttachment, requestApplicationNotification,
	requestApplicationPremiumSettings,
	requestDeleteDocument,
	transferApplicationBetweenSolicitorUsers, requestPatchTransferApplicationBetweenSolicitors, requestDeleteApplicationPremiumSettings
} from "../actions/applicationPolicy";
import {requestGetSolicitors} from "../actions/agentsList";
import {requestLawsysFirmsWithAgents} from "../actions/lawsysFirms";
import {
	changeNewAppField, fetchApplicationByIdAfterApplicationAnswerUpdate, requestGetSelectedApplication,
	requestPatchApplication
} from "../actions/newApplication";
import {
	changeOverviewPolicyField, changeOverViewTabReadMoreState, overviewTabPageShift
} from "../actions/overviewTab";
import {requestPatchNotification} from "../actions/notifications";
import {changeUpdatePolicyField, getCostsSummary} from "../actions/updateTab";
import {
	requestPremiumSettingsDamages
} from "../actions/premiumSettings";
import { push,replace } from 'connected-react-router'
import _ from 'lodash';
import {getUserGroups} from "../actions/usersList";
import {_getFileFromBase64, isAragUser, isSolicitorUser} from "../helpers/functions";
import {POLICY_LINK_TO_POLICY_TAB_LOOKUP_TABLE} from "../helpers/variables";
import {resetApplicationPremium} from "../actions/premiumSettingsWizard";
import {checkLawsysFirmBankAccountValidity} from "../actions/lawsysFirms";
import { resetApplicationStagedPremium } from '../reducers/stagedPremiumsWizard';
import { resetStagedPremiumState } from '../reducers/stagedPremiums';
import { getApplicableInternalAlerts } from '../reducers/internalAlerts';
import { POLICY_STATUS_MN_ABANDONED, POLICY_STATUS_MN_ENTERED_IN_ERROR,POLICY_STATUS_MN_FOURTEEN_DAY_COOLING_OFF_PERIOD, POLICY_STATUS_MN_CLOSED, POLICY_SCHEDULE } from '../helpers/constants'; 

class ApplicationPolicyHOC extends Component {

	constructor(props){
		super(props);
		this.state = {
			isEditingApplicationPremium: false,
			costsSummaryModalOpen:false,
		}
	}

	editApplicationPremium = () => {
		this.setState({
			...this.state,
			isEditingApplicationPremium: true
		})
	};

	cancelEditOfApplicationPremium = () => {
		this.props.resetApplicationStagedPremium();
		this.props.resetApplicationPremium();
		this.props.resetStagedPremiumState();
		this.props.requestDeleteApplicationPremiumSettings({
			applicationId:this.props.applicationsAndPolicies.selectedApplication.id,
			appPremiumSettingId:this.props.applicationPolicy.premiumSettings?.id
		});
		this.setState({
			...this.state,
			isEditingApplicationPremium: false
		})
	};

	componentWillMount() {
        if(isNaN(_.last(this.props.router.location.pathname.split('/')))){
            this.props.replace(this.props.match.url);
            this.props.selectActiveTab(POLICY_LINK_TO_POLICY_TAB_LOOKUP_TABLE[_.last(this.props.router.location.pathname.split('/'))])
        }

        if(this.props.router.location.pathname.includes('wording')){
        	this.props.replace(this.props.match.url);
        	this.props.changeApplicationPolicySettings('wordingId', _.last(this.props.router.location.pathname.split('/')));
            this.props.selectActiveTab(POLICY_LINK_TO_POLICY_TAB_LOOKUP_TABLE['wording'])
		}

		if(this.props.router.location.pathname.includes('ipid')){
			this.props.replace(this.props.match.url);
			this.props.selectActiveTab(POLICY_LINK_TO_POLICY_TAB_LOOKUP_TABLE['ipid'])
		}

		let route = this.props.router.location.pathname;
		let splitedRoute = _.split(route,'/',4);
		let splitId = splitedRoute[3];

		this.props.requestPremiumSettingsDamages();
		if (route.includes('/application-and-policies/application-policy')) {
			this.props.getSelectedApplication(splitId);
			this.props.requestApplicationNotification({applicationId:splitId});
		} else {
			if ((Object.keys(this.props.applicationsAndPolicies.selectedApplication).length !== 0 && this.props.applicationsAndPolicies.selectedApplication.constructor === Object) && (!this.props.newApplication.fetchingSelectedApp)) {
				this.props.getSelectedApplication(this.props.applicationsAndPolicies.selectedApplication.id);
			}
		}

		if(isAragUser(this.props.user.loggedInUser.roles)){
			this.props.getUserGroups();
			this.props.requestLawsysFirmsWithAgents(this.props.user.loggedInUser.token);
		}

		if(isAragUser(this.props.user.loggedInUser.roles)){
			if ((Object.keys(this.props.applicationsAndPolicies.selectedApplication).length !== 0 && 
			this.props.applicationsAndPolicies.selectedApplication.constructor === Object) &&
			 (!this.props.newApplication.fetchingSelectedApp)) 
			 {
				this.props.getApplicableInternalAlerts(this.props.applicationsAndPolicies.selectedApplication.id);
			}
		}
	}

	componentWillReceiveProps = (nextProps) => {
		if(this.props.applicationPolicy.fetchingDocument && !nextProps.applicationPolicy.fetchingDocument && nextProps.applicationPolicy.failedToGetDocumentMsg === ''){
			_getFileFromBase64(nextProps.applicationPolicy.documentToDownload);
		}

		if(
			isAragUser(this.props.user.loggedInUser.roles)
			&& this.props.newApplication.fetchingSelectedApp && !nextProps.newApplication.fetchingSelectedApp
			&& nextProps.applicationsAndPolicies.selectedApplication.id
		){
			this.props.checkLawsysFirmBankAccountValidity({
				lawsysId: nextProps.applicationsAndPolicies.selectedApplication.lawsysId
			});
		}
		if (isSolicitorUser(this.props.user.loggedInUser.roles) &&
			this.props.newApplication.application &&
			this.props.newApplication.fetchingSelectedApp && 
			!nextProps.newApplication.fetchingSelectedApp &&
			(nextProps.newApplication.application.policyStatusMachineName === "Won" ||
			nextProps.newApplication.application.policyStatusMachineName === "WonPart36" ||
			nextProps.newApplication.application.policyStatusMachineName === "WonRule49") &&
			nextProps.updateTab.costsSummary === '' && 
			nextProps.updateTab.costsSummaryError === '') {
				
			this.props.getCostsSummary(nextProps.newApplication.application.id);
			this.setState({ ...this.state, costsSummaryModalOpen: true })
		}
		// re fetch policy answers and policy in general after updating policy question answers
		if(
			this.props.newApplication.updatingQuestionAnswer && !nextProps.newApplication.updatingQuestionAnswer
			&& !nextProps.newApplication.updatingQuestionAnswerFail
		) {
			this.props.fetchApplicationByIdAfterApplicationAnswerUpdate({
				applicationId: this.props.applicationsAndPolicies.selectedApplication.id
			});
		}

		// re fetch policy answers and policy in general after transferring solicitors
		if(
			this.props.applicationPolicy.transferringApplication && !nextProps.applicationPolicy.transferringApplication
			&& nextProps.applicationPolicy.badResponseTransferApplication === ""
		) {
			this.props.getSelectedApplication(this.props.applicationsAndPolicies.selectedApplication.id);
		}

		if(this.props.applicationPolicy.documentData != nextProps.applicationPolicy.documentData)
		{
			const link = document.createElement("a");
			link.href = 'data:application/pdf;base64,' + nextProps.applicationPolicy.documentData;
			link.download = 'ARAG_Policy_' + POLICY_SCHEDULE + '_' + nextProps.newApplication.selectedApplication.aragReference + '_' + _.replace(nextProps.newApplication.selectedApplication.clientName, / /g, '_') +'.pdf';
			link.click();
		}
		if(nextProps.applicationPolicy.premiumSettingsChanged){
			this.props.changeApplicationPolicySettings('premiumSettingsChanged',false)
			this.props.getSelectedApplication(this.props.applicationsAndPolicies.selectedApplication.id);
		}
	};

	// getFileFromBase64 = (documentToDownload) => {
	// 	download(documentToDownload.encodedFile, documentToDownload.name, documentToDownload.fileType, 'base64');
	// };

	getBase64 = (file) => {
		let reader = new FileReader();
		reader.readAsDataURL(file);
		let attachment = {
			name: file.name,
			encodedFile: '',
			fileType: file.type
		};
		let props = this.props;
		reader.onload = function () {
			attachment = {...attachment, encodedFile: reader.result.substring(reader.result.indexOf("base64,") + 7)};
			props.updatePolicyAttachmentsChange(attachment)
		};
		reader.onerror = function (error) {
			console.log('Error: ', error);
		};
	};

	handleSolicitorFirmSelect = (lawsysId)=> {
		const parameters = {
			orderAsc: true,
			orderBySolicitorName: false,
			orderByLawsysId: false,
			orderByLawsysName:false,
			orderByUserName: true,
			limit: null,
			offset: 0,
			lawsysId: lawsysId,
			search: null,
		};
		this.props.getSolicitors(parameters);
		this.props.transferApplicationBetweenSolicitorUsers('solicitorFirmIdSelected', lawsysId);
	}


	handleSolicitorSelect = (userId)=>{
		this.props.transferApplicationBetweenSolicitorUsers('solicitorFirmUserIdSelected', userId);
	}

	userDropDownStatusOptions = (status, referredToName,applicationAcceptedStatusesTransitions, policyStatusMachineName) => {
		let referredOptions = [
			{key: 'Referred to Medical Expert', value: 'Referred to Medical Expert'},
			{key: 'Referred to Technical Underwriter', value: 'Referred to Technical Underwriter'},
			{key: 'Referred to Underwriter', value: 'Referred to Underwriter'}
		];

		let transitions = applicationAcceptedStatusesTransitions?.transitions.filter(transition => transition.item1 === status && transition.item2 !== 'Referred')
			.map(transition => ({key: transition.item2 , value: transition.item2}));

		if (policyStatusMachineName  === POLICY_STATUS_MN_ABANDONED || 
			policyStatusMachineName  === POLICY_STATUS_MN_ENTERED_IN_ERROR|| 
			policyStatusMachineName  === POLICY_STATUS_MN_FOURTEEN_DAY_COOLING_OFF_PERIOD || 
			policyStatusMachineName  === POLICY_STATUS_MN_CLOSED)
		{
			referredOptions = [];
		}
		else if(referredToName === 'Medical Expert'){
			referredOptions =  referredOptions.filter(option=> option.key !== 'Referred to Medical Expert');
		}
		else if (referredToName === 'Underwriter'){
			referredOptions = referredOptions.filter(option=> option.key !== 'Referred to Underwriter');
		}
		else if (referredToName === 'Technical Underwriter'){
			referredOptions =referredOptions.filter(option=> option.key !== 'Referred to Technical Underwriter');
		 }
		else {
			referredOptions = [	];
		}

		return [{key: '', value: ''},...referredOptions,...transitions]
	};

	handleStatusChange = (app) =>{
		if(app.policyStatus !== "Live"){
			this.props.changeApplication(app);
		}else{
			this.props.getApplicationPremiumSettings({id:app.id, openModal:true});
		}
	};

	_getPolicyStatusLabel = () => {
		let str = '';
		str = this.props.newApplication.selectedApplication.policyStatus;
		if(this.props.newApplication.selectedApplication.policyStatus === 'Referred'){
			if(isAragUser(this.props.user.loggedInUser.roles)){
				if(this.props.newApplication.selectedApplication.referredToName){
					return str += ' to ' + this.props.newApplication.selectedApplication.referredToName
				}
                if(this.props.newApplication.selectedApplication.roleGroupName){
                    return str += ' to ' + this.props.newApplication.selectedApplication.roleGroupName
                }
			}
		}
		return str;
	};

	_updatePolicyStatus = () => {
        if(this.props.applicationPolicy.selectedStatus === "Live" &&
            !this.props.applicationPolicy.openPremiumSettingsModal
		){
            this.props.getApplicationPremiumSettings(
                {id:this.props.newApplication.selectedApplication.id, openModal:true,premiumType: this.props.applicationPolicy.premiumSettingsType});
            return false;
        }
        let selectedReferredOption;
        let filteredStatus = '';

        if(this.props.applicationPolicy.selectedStatus.includes('Medical Expert')) {
            filteredStatus = 'Medical Expert';
        }
        else if(this.props.applicationPolicy.selectedStatus.includes('Technical Underwriter')) {
            filteredStatus = 'Technical Underwriter';
        }
        else if(this.props.applicationPolicy.selectedStatus.includes('Underwriter')) {
            filteredStatus = 'Underwriter';
        }
        let gr = _.find(this.props.userGroups, group => {
            return group.roleName === filteredStatus;
        });
        if (gr) {
            selectedReferredOption = gr.id
        }
        this.props.changeApplication({
            id: this.props.newApplication.selectedApplication.id,
            policyStatus: this.props.applicationPolicy.selectedStatus.includes('Referred')?
                'Referred':this.props.applicationPolicy.selectedStatus,
            roleGroupId: selectedReferredOption,
            sendEmail: this.props.applicationPolicy.sendEmailNotification,
            abandonedReason: this.props.newApplication.abandonedReason?this.props.newApplication.abandonedReason: null,
            rejectedReason: this.props.newApplication.rejectedReason?this.props.newApplication.rejectedReason: null,
            referralReasons: this.props.newApplication.referredReason?
                [this.props.newApplication.referredReason]
                :
                null
        })
    };

	_transferApplication = (confirmed) => {
		this.props.requestPatchTransferApplicationBetweenSolicitors({
			applicationId: this.props.newApplication.selectedApplication.id,
			sendBody: {
				OldSolicitorLawsysFirmId: this.props.newApplication.selectedApplication.lawsysId,
				OldApplicationUserId: this.props.newApplication.selectedApplication.applicationUserId,
				NewSolicitorLawsysFirmId: this.props.applicationPolicy.solicitorFirmIdSelected,
				NewApplicationUserId: this.props.applicationPolicy.solicitorFirmUserIdSelected,
				isConfirmed: confirmed
			}
		});
	}

	_changePolicyTab = (tabName) => {
		this.props.selectActiveTab(tabName);
	};

	//open advance disbursements application form mofal
	_openAdvancedDisbursementsApplicationModal = () => {
		this.props.changeApplicationPolicySettings('advancedDisbursementsApplicationModalOpen', true);
	};

	_closeAdvancedDisbursementsApplicationModal = () => {
        this.props.changeApplicationPolicySettings('advancedDisbursementsApplicationModalOpen', false);
	};
	toggleCostsSummaryModal = () => {
        this.setState({...this.state,costsSummaryModalOpen:!this.state.costsSummaryModalOpen})
	};

	toggleInternalAlertModal = () => {
		this.setState({...this.state,internalAlertModal:!this.state.internalAlertModal});
	};
	render() {

		return (
			<ApplicationPolicy
                badResponseAppPsMessage={this.props.badResponseAppPsMessage}
				isEditingApplicationPremium={this.state.isEditingApplicationPremium}
				editApplicationPremium={this.editApplicationPremium}
				cancelEditOfApplicationPremium={this.cancelEditOfApplicationPremium}
                _getPolicyStatusLabel={this._getPolicyStatusLabel}
                _changePolicyTab={this._changePolicyTab}
                match={this.props.match}
				_openAdvancedDisbursementsApplicationModal={this._openAdvancedDisbursementsApplicationModal}
                _closeAdvancedDisbursementsApplicationModal={this._closeAdvancedDisbursementsApplicationModal}
                _changeNewAppField={this.props.changeNewAppField}
				router={this.props.router}
				applicationAcceptedStatusesTransitions={this.props.applicationAcceptedStatusesTransitions}
				UserDropDownStatusOptions={this.userDropDownStatusOptions}
				ChangeApplicationPolicySettings={this.props.changeApplicationPolicySettings}
				CheckUserOverviewTabCheckBox={this.props.checkUserOverviewTabCheckBox}
				RequestDeleteDocument={this.props.requestDeleteDocument}
				PageShift={this.props.overviewTabPageShift}
				CalculateFeaturedOverview={this.calculateFeaturedOverview}
				ChangeOverViewTabReadMoreState={this.props.changeOverViewTabReadMoreState}
				User={this.props.user}
				handleOverviewInputChange={this.props.changeOverviewPolicyField}
				handleOverviewTabSubmit={this.handleOverviewTabSubmit}
				OnDropOverview={this.onDropOverview}
				UpdateTab={this.props.updateTab}
				SavedApplicationAttachments={this.props.newApplication.hasOwnProperty('attachmentsForDisplay')?this.props.newApplication.attachmentsForDisplay:[]}
				SelectedApp={this.props.newApplication.selectedApplication}
				SelectActiveTab={this.props.selectActiveTab}
				Store={this.props.applicationPolicy}
				requestPatchNotification={this.props.requestPatchNotification}
                _updatePolicyStatus={this._updatePolicyStatus}
				handleStatusChange = {this.handleStatusChange}
				newApplication = {this.props.newApplication}
				requestApplicationAttachment = {this.props.requestApplicationAttachment}
				selectedApplication = {this.props.applicationsAndPolicies.selectedApplication}
				handleSolicitorSelect={this.handleSolicitorSelect}
				handleSolicitorFirmSelect={this.handleSolicitorFirmSelect}
				SolicitorFirms={this.props.lawsysFirms}
				TransferApplicationBetweenSolicitorUsers={this.props.transferApplicationBetweenSolicitorUsers}
				_transferApplication={this._transferApplication}
				AgentsList={this.props.agentsList}
				costsSummaryModal = {this.state.costsSummaryModalOpen}
				toggleCostsSummaryModal={this.toggleCostsSummaryModal}
				changeUpdatePolicyField={this.props.changeUpdatePolicyField}
				internalAlerts={this.props.internalAlerts}
				toggleInternalAlertModal={this.toggleInternalAlertModal}
				internalAlertsModalOpen = {this.state.internalAlertModal}
			/>
		)
	}
}

const mapStateToProps = (state) => {
	return {
        userGroups: state.usersList.userGroups,
		router: state.router,
		applicationPolicy: state.applicationPolicy,
		applicationAcceptedStatusesTransitions: state.applicationAcceptedStatusesTransitions,
		applicationsAndPolicies: state.applicationsAndPolicies,
		updateTab: state.updateTab,
		user: state.user,
		newApplication: state.newApplication,
        badResponseAppPsMessage: state.premiumSettingsWizard.badResponseMsg,
		agentsList: state.agentsList,
        lawsysFirms: state.lawsysFirms,
		internalAlerts:state.internalAlerts.applicableInternalAlerts
	}
};

const mapDispatchToProps = (dispatch) => {
	return {
		selectActiveTab: (tab) => {
			dispatch(changeActiveTab(tab))
		},
		getSelectedApplication: (id) => {
			dispatch(requestGetSelectedApplication(id))
		},
		changeOverviewPolicyField: (field, value) => {
			dispatch(changeOverviewPolicyField(field, value))
		},
		changeOverViewTabReadMoreState: (key, value) => {
			dispatch(changeOverViewTabReadMoreState(key, value));
		},
		overviewTabPageShift: (direction, totalPaginationBoxes) => {
			dispatch(overviewTabPageShift(direction, totalPaginationBoxes));
		},
		requestDeleteDocument: (applicationId, attachmentId, relativeUrl) => {
			dispatch(requestDeleteDocument(applicationId, attachmentId, relativeUrl));
		},
		checkUserOverviewTabCheckBox: (checkBoxLabel) => {
			dispatch(checkUserOverviewTabCheckBox(checkBoxLabel));
		},
		changeApplicationPolicySettings: (setting, value) => {
			dispatch(changeApplicationPolicySettings(setting, value));
		},
		requestPatchNotification: (notificationId, viewed, applicationId) => {
			dispatch(requestPatchNotification(notificationId, viewed, applicationId));
		},
		changeApplication: (app) => {
			dispatch(requestPatchApplication(app));
		},
		getApplicationPremiumSettings: (payload) => {
			dispatch(requestApplicationPremiumSettings(payload));
		},
		requestPremiumSettingsDamages: () => {
			dispatch(requestPremiumSettingsDamages())
		},
		requestApplicationAttachment: (payload) => {
			dispatch(requestApplicationAttachment(payload))
		},
		requestApplicationNotification: (payload) => {
			dispatch(requestApplicationNotification(payload))
		},
        changeNewAppField: (field, value) => {
            dispatch(changeNewAppField(field, value))
        },
        getUserGroups: () => {
			dispatch(getUserGroups())
		},
		push: (url) => {
			dispatch(push(url))
		},
        replace: (url) => {
			dispatch(replace(url))
		},
		resetApplicationPremium: (payload) => {
			dispatch(resetApplicationPremium(payload))
		},
		resetApplicationStagedPremium: (payload) => {
			dispatch(resetApplicationStagedPremium(payload))
		},
		resetStagedPremiumState: (payload) => {
			dispatch(resetStagedPremiumState(payload))
		},
		checkLawsysFirmBankAccountValidity: (payload) => {
			dispatch(checkLawsysFirmBankAccountValidity(payload))
		},
		fetchApplicationByIdAfterApplicationAnswerUpdate: (payload) => {
			dispatch(fetchApplicationByIdAfterApplicationAnswerUpdate(payload))
		},
		requestLawsysFirmsWithAgents: (payload) => {
            dispatch(requestLawsysFirmsWithAgents(payload))
        },
		transferApplicationBetweenSolicitorUsers: (setting, value) => {
			dispatch(transferApplicationBetweenSolicitorUsers(setting, value));
		},
		requestPatchTransferApplicationBetweenSolicitors: (payload) => {
			dispatch(requestPatchTransferApplicationBetweenSolicitors(payload))
		},
		requestDeleteApplicationPremiumSettings: (id) => {
			dispatch(requestDeleteApplicationPremiumSettings(id))
		},
		getSolicitors: (payload) => {
            dispatch(requestGetSolicitors(payload))
        },
		getCostsSummary: (payload) => {
            dispatch(getCostsSummary(payload))
        },
		changeUpdatePolicyField: (field,value) => {
            dispatch(changeUpdatePolicyField(field,value))
        },
		getApplicableInternalAlerts: (payload) => {
            dispatch(getApplicableInternalAlerts(payload))
        },
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(ApplicationPolicyHOC);
